export enum ContractType {
  ENTERPRISE = 'enterprise',
  SUBSCRIPTION = 'subscription',
  REFERRAL = 'referral',
  RESELLER = 'reseller',
}
